<template>
  <div id="app" class="page-wrap">
    <router-view />
  </div>
</template>
<script>
  import {mapMutations} from "vuex";

  export default {
    name:'App',
    components:{},
    data () {
      return{
        windowWidth:0,
        headerHeight:50
      }
    },
    beforeDestroy() {
    },
    watch: {
      '$route'(to, from) {
        this.init()
      }
    },
    mounted(){
      this.updateWindowDimensions()
      window.addEventListener('resize', this.updateWindowDimensions)
    },
    methods:{
      ...mapMutations(['setScreenWidth','setScrollTop']),
      init(){
        
        setTimeout(()=>{
          this.handleScroll()
          window.addEventListener('scroll', this.handleScroll)
        },100)
        
      },
      
      updateWindowDimensions() {
        this.windowWidth = window.innerWidth;
        this.$store.commit('setScreenWidth',this.windowWidth)
        this.handleScroll()
      },
      handleScroll() {
        let scrollPosition = window.scrollY || window.pageYOffset;
        this.$store.commit('setScrollTop',scrollPosition)
        let list = this.$el.querySelectorAll('.lazyDiv');
        if(list.length){
          let _scrollPosition = scrollPosition + (list[0].offsetTop + this.headerHeight) + 200;
          for (let i = 0; i < list.length; i++) {
            const contentTop = list[i].offsetTop + this.headerHeight;
            if (_scrollPosition > contentTop) {
              list[i].classList.add('fade-out');
              // setTimeout(()=>{
              //   list[i].classList.remove('fade-out')
              // },1000)
            }
          }
        }else{
          setTimeout(()=>{
            this.handleScroll()
          },100)
        }
      }
    }
  }
</script>
<style lang="scss">
  @import "@/assets/css/global";
  html{scroll-behavior: smooth;}
  .page-wrap{max-width:100%;overflow-x:hidden;}
</style>
